import React from 'react';
import { Card } from "react-bootstrap";
import styles from '../SessionHistoryDetailView.module.css';

const DiagnosisConcernsSection = ({
  sessionFormData,
  primaryDiagnosisError,
  diagnosisCodeRef,
  secondaryDiagnosisCodeRef,
  tertiaryDiagnosisCodeRef,
  isPrimaryDiagnosisDropdownOpen,
  isSecondaryDiagnosisDropdownOpen,
  isTertiaryDiagnosisDropdownOpen,
  togglePrimaryDiagnosisDropdown,
  toggleSecondaryDiagnosisDropdown,
  toggleTertiaryDiagnosisDropdown,
  primaryDiagnosisSearchTerm,
  secondaryDiagnosisSearchTerm,
  tertiaryDiagnosisSearchTerm,
  setPrimaryDiagnosisSearchTerm,
  setSecondaryDiagnosisSearchTerm,
  setTertiaryDiagnosisSearchTerm,
  diagnosisSearchLoading,
  secondaryDiagnosisSearchLoading,
  tertiaryDiagnosisSearchLoading,
  diagnosisSearchError,
  secondaryDiagnosisSearchError,
  tertiaryDiagnosisSearchError,
  primaryDiagnosisResults,
  secondaryDiagnosisResults,
  tertiaryDiagnosisResults,
  handlePrimaryDiagnosisSelect,
  handleSecondaryDiagnosisSelect,
  handleTertiaryDiagnosisSelect,
  setIsPrimaryDiagnosisDropdownOpen,
  setIsSecondaryDiagnosisDropdownOpen,
  setIsTertiaryDiagnosisDropdownOpen
}) => {
  return (
    <Card id="diagnosis" className={styles.card}>
      <h3 className={styles.sectionHeading}>
        Diagnosis
      </h3>

      <label className={styles.labelWithMarginXLarge}>
        Primary Diagnosis:
      </label>

      {primaryDiagnosisError && (
        <div className={styles.errorMessage} style={{ marginTop: "4px", marginBottom: "8px" }}>
          {primaryDiagnosisError}
        </div>
      )}

      {/* Primary Diagnosis */}
      <div className={styles.diagnosisSelector}>
        <div className={styles.diagnosisSelectorHeader} ref={diagnosisCodeRef}>
          <div className={styles.diagnosisCodeField}>
            <label className={styles.diagnosisColumnLabel}>Diagnosis code</label>
            <input
              type="text"
              className={`${styles.diagnosisInput} ${isPrimaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.primaryDiagnosis || ""}
              placeholder="Search"
              readOnly
              onClick={togglePrimaryDiagnosisDropdown}
            />
          </div>

          <div className={styles.diagnosisDescriptionField}>
            <label className={styles.diagnosisColumnLabel}>Description</label>
            <input
              type="text"
              className={`${styles.diagnosisInputDesc} ${styles.readonly} ${isPrimaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.primaryDiagnosisDescription || ""}
              placeholder="None Selected"
              readOnly
            />
          </div>

          {isPrimaryDiagnosisDropdownOpen && (
            <div className={styles.diagnosisDropdownPanel}>
              <div className={styles.diagnosisSearchInput}>
                <svg
                  className={styles.diagnosisSearchIcon}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 14L11.1 11.1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input
                  type="text"
                  value={primaryDiagnosisSearchTerm}
                  onChange={(e) => setPrimaryDiagnosisSearchTerm(e.target.value)}
                  placeholder="Type here to search through 1000's of ICD-10 codes"
                  className={styles.diagnosisSearchField}
                />
              </div>
              <div className={styles.diagnosisResults}>
                {diagnosisSearchLoading ? (
                  <div className={styles.diagnosisStatusMessage}>Searching ICD-10 codes...</div>
                ) : diagnosisSearchError ? (
                  <div className={styles.diagnosisStatusMessage}>{diagnosisSearchError}</div>
                ) : primaryDiagnosisResults.length === 0 ? (
                  <div className={styles.diagnosisStatusMessage}>No diagnosis codes found.</div>
                ) : (
                  primaryDiagnosisResults.map((result) => (
                    <button
                      type="button"
                      key={`${result.code}-${result.description}`}
                      className={styles.diagnosisResultRow}
                      onClick={() => {
                        handlePrimaryDiagnosisSelect(result);
                        setIsPrimaryDiagnosisDropdownOpen(false);
                      }}
                    >
                      <span>{result.code}</span> - {result.description}
                    </button>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Secondary Diagnosis */}
      <label className={styles.labelWithMarginXLarge}>
        Secondary Diagnosis:
      </label>

      <div className={styles.diagnosisSelector}>
        <div className={styles.diagnosisSelectorHeader} ref={secondaryDiagnosisCodeRef}>
          <div className={styles.diagnosisCodeField}>
            <label className={styles.diagnosisColumnLabel}>Diagnosis code</label>
            <input
              type="text"
              className={`${styles.diagnosisInput} ${isSecondaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.secondaryDiagnosis || ""}
              placeholder="Search"
              readOnly
              onClick={toggleSecondaryDiagnosisDropdown}
            />
          </div>

          <div className={styles.diagnosisDescriptionField}>
            <label className={styles.diagnosisColumnLabel}>Description</label>
            <input
              type="text"
              className={`${styles.diagnosisInputDesc} ${styles.readonly} ${isSecondaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.secondaryDiagnosisDescription || ""}
              placeholder="None Selected"
              readOnly
            />
          </div>

          {isSecondaryDiagnosisDropdownOpen && (
            <div className={styles.diagnosisDropdownPanel}>
              <div className={styles.diagnosisSearchInput}>
                <svg
                  className={styles.diagnosisSearchIcon}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 14L11.1 11.1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input
                  type="text"
                  value={secondaryDiagnosisSearchTerm}
                  onChange={(e) => setSecondaryDiagnosisSearchTerm(e.target.value)}
                  placeholder="Type here to search through 1000's of ICD-10 codes"
                  className={styles.diagnosisSearchField}
                />
              </div>
              <div className={styles.diagnosisResults}>
                {secondaryDiagnosisSearchLoading ? (
                  <div className={styles.diagnosisStatusMessage}>Searching ICD-10 codes...</div>
                ) : secondaryDiagnosisSearchError ? (
                  <div className={styles.diagnosisStatusMessage}>{secondaryDiagnosisSearchError}</div>
                ) : secondaryDiagnosisResults.length === 0 ? (
                  <div className={styles.diagnosisStatusMessage}>No diagnosis codes found.</div>
                ) : (
                  secondaryDiagnosisResults.map((result) => (
                    <button
                      type="button"
                      key={`secondary-${result.code}-${result.description}`}
                      className={styles.diagnosisResultRow}
                      onClick={() => {
                        handleSecondaryDiagnosisSelect(result);
                        setIsSecondaryDiagnosisDropdownOpen(false);
                      }}
                    >
                      <span>{result.code}</span> - {result.description}
                    </button>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Tertiary Diagnosis */}
      <label className={styles.labelWithMarginXLarge}>
        Tertiary Diagnosis:
      </label>

      <div className={styles.diagnosisSelector}>
        <div className={styles.diagnosisSelectorHeader} ref={tertiaryDiagnosisCodeRef}>
          <div className={styles.diagnosisCodeField}>
            <label className={styles.diagnosisColumnLabel}>Diagnosis code</label>
            <input
              type="text"
              className={`${styles.diagnosisInput} ${isTertiaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.tertiaryDiagnosis || ""}
              placeholder="Search"
              readOnly
              onClick={toggleTertiaryDiagnosisDropdown}
            />
          </div>

          <div className={styles.diagnosisDescriptionField}>
            <label className={styles.diagnosisColumnLabel}>Description</label>
            <input
              type="text"
              className={`${styles.diagnosisInputDesc} ${styles.readonly} ${isTertiaryDiagnosisDropdownOpen ? styles.diagnosisInputOpen : ""}`}
              value={sessionFormData.tertiaryDiagnosisDescription || ""}
              placeholder="None Selected"
              readOnly
            />
          </div>

          {isTertiaryDiagnosisDropdownOpen && (
            <div className={styles.diagnosisDropdownPanel}>
              <div className={styles.diagnosisSearchInput}>
                <svg
                  className={styles.diagnosisSearchIcon}
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                >
                  <path
                    d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M14 14L11.1 11.1"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <input
                  type="text"
                  value={tertiaryDiagnosisSearchTerm}
                  onChange={(e) => setTertiaryDiagnosisSearchTerm(e.target.value)}
                  placeholder="Type here to search through 1000's of ICD-10 codes"
                  className={styles.diagnosisSearchField}
                />
              </div>
              <div className={styles.diagnosisResults}>
                {tertiaryDiagnosisSearchLoading ? (
                  <div className={styles.diagnosisStatusMessage}>Searching ICD-10 codes...</div>
                ) : tertiaryDiagnosisSearchError ? (
                  <div className={styles.diagnosisStatusMessage}>{tertiaryDiagnosisSearchError}</div>
                ) : tertiaryDiagnosisResults.length === 0 ? (
                  <div className={styles.diagnosisStatusMessage}>No diagnosis codes found.</div>
                ) : (
                  tertiaryDiagnosisResults.map((result) => (
                    <button
                      type="button"
                      key={`tertiary-${result.code}-${result.description}`}
                      className={styles.diagnosisResultRow}
                      onClick={() => {
                        handleTertiaryDiagnosisSelect(result);
                        setIsTertiaryDiagnosisDropdownOpen(false);
                      }}
                    >
                      <span>{result.code}</span> - {result.description}
                    </button>
                  ))
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};

export default DiagnosisConcernsSection;

